import { errorToast } from "@/v2-ui/toast"
import UserTenantTypePicker, {
  type UserTenantTypePickerProps,
} from "@/v2-backoffice-client/user/tenant/type/UserTenantTypePicker"
import { useTenantUserTypeMutation } from "@/v2-backoffice-client/tenant/user/type/tenant.user.type.mutation"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"

export type TenantUserTypePickerProps = Omit<
  UserTenantTypePickerProps,
  "value" | "onChange"
> & {
  userTenant: UserTenantFragment
}

function TenantUserTypePicker(props: TenantUserTypePickerProps) {
  const { userTenant, ...userTenantTypePickerProps } = props

  const [updateType, { error, loading }] = useTenantUserTypeMutation()
  errorToast(error, { title: "Failed to update role" })

  return (
    <UserTenantTypePicker
      isLoading={loading}
      value={userTenant.UserTenantTypeCode}
      onChange={(code) => {
        updateType({
          variables: { input: { Id: userTenant.Id, UserTenantTypeCode: code } },
        })
      }}
      {...userTenantTypePickerProps}
    />
  )
}

export default TenantUserTypePicker
